import classNames from 'classnames'
import React from 'react'

import { AlertIcon } from '../icon/icon.js'

export interface AlertProps {
    className?: string
    items: AlertItemProps[]
}

export interface AlertItemProps {
    text: string
    url?: string
    onClick?: () => void
}

export const Alert = (props: AlertProps): JSX.Element => (
    <div className={classNames('alert', props.className)}>
        <AlertIcon className="alert__icon" />
        <div>
            {props.items.map((item, index) => (
                <AlertItem key={index} {...item} />
            ))}
        </div>
    </div>
)

const AlertItem = (props: AlertItemProps): JSX.Element => {
    const Element = props.url ? 'a' : 'span'

    return (
        <Element
            className={classNames('alert__item', (props.url || props.onClick) && 'alert__item--clickable')}
            href={props.url}
            onClick={props.onClick}
        >
            {props.text}
        </Element>
    )
}
